import { useEffect, useRef, useState } from 'react';
import { useViewport } from 'hooks/3catinfo/useViewport';
import Compartir from 'components/3catinfo/Compartir';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './stickyHeader.module.scss';
import AfegeixALaLlista from 'components/3catinfo/AfegeixALaLlista';

const getProgress = (contentPosition) => {
    const { contentTop, contentHeight } = contentPosition;
    const distance = contentHeight + contentTop;
    return Math.max(0, Math.min(100, 100 - (distance / contentHeight) * 100));
};

const ProgressBar = (props) => {
    const { contentPosition } = props;

    if (__isEmpty(contentPosition)) return <></>;
    const progress = getProgress(contentPosition);

    return (
        <div className={styles.progressBar}>
            <span className={styles.bar} style={{ width: progress + '%' }}>
                &nbsp;
            </span>
        </div>
    );
};

const StickyHeader = (props) => {
    const { titol, tipologia, id, programaTV, programaRadio } = props;
    const { zoomNavigator } = useViewport();
    const [isSticky, setIsSticky] = useState(false);
    const [contentPosition, setContentPosition] = useState({});
    const contentRef = useRef(null);

    const tallarTitol = (titol) => {
        const nouTitol = titol.substring(0, 70);
        const ultimEspai = nouTitol.lastIndexOf(' ');
        let char = nouTitol[ultimEspai - 1];
        let _end = ultimEspai;
        if (char === ',' || char === ':' || char === '.') {
            _end--;
        }
        return [`${nouTitol.substring(0, _end)}...`];
    };
    const titolSticky = titol.length > 70 ? tallarTitol(titol) : titol;

    const stylesCompartir = clsx({
        [styles.compartir]: true,
        [styles.ambZoom]: zoomNavigator > 2
    });

    const stylesContentHeader = clsx({
        [styles.contentHeader]: true,
        [styles.ambZoom400]: zoomNavigator > 3.5
    });

    useEffect(() => {
        const showStickyHeader = () => {
            if (contentRef.current) {
                const boundingRect = contentRef.current.getBoundingClientRect();
                const contentTop = boundingRect.top;
                const contentBottom = boundingRect.bottom;
                const contentHeight = boundingRect.height;
                setContentPosition({ contentTop, contentBottom, contentHeight });
                setIsSticky(contentTop < 0);
            }
        };
        window.addEventListener('scroll', showStickyHeader);
        return () => {
            window.removeEventListener('scroll', showStickyHeader);
        };
    }, []);

    const audiencies = {
        programa: programaTV?.desc || programaRadio?.desc,
        pagename: titol
    };

    return (
        <div className={styles.stickyHeader} ref={contentRef} data-testid='item-noti-sticky'>
            {isSticky && (
                <div className={stylesContentHeader}>
                    <div className={styles.innerHeader}>
                        <div className={styles.titolNoti}>
                            <p className={styles.titol}>
                                <span dangerouslySetInnerHTML={{ __html: titolSticky }}></span>
                            </p>
                        </div>

                        <div className={styles.contentIcons}>
                            <AfegeixALaLlista
                                tipologia={tipologia}
                                id={id}
                                estil='negatiu'
                                isBlanc={true}
                                mida='small'
                                audiencies={audiencies}
                                textTooltipInactiu='Guarda&#39;t la not&#237;cia'
                            />
                            <Compartir
                                className={stylesCompartir}
                                estil='negatiu'
                                titolCompartirMobil={titol}
                                titol={titol}
                                midaBoto='small'
                                obreEsquerra={true}
                            />
                        </div>
                    </div>
                    <ProgressBar contentPosition={contentPosition} />
                </div>
            )}

            <div className={styles.contentNoti}>{props.children}</div>
        </div>
    );
};

export default StickyHeader;
